// @flow
import {
    SET_CLUSTER_SESSION_DATA,
    SET_CLUSTER_LIST_DATA,
    SET_ACTIVE_RUNNING_SESSION_DATA,
    SET_CLIENT_DATA,
    SET_CLIENT_CHECKIN_QUESTIONNAIRE_DATA,
    SET_CHIME_SESSION_DATA,
    SET_ATTENDEES,
    SET_WAITING_ROOM_MEMBERS,
    SET_JOIN_DATA,
    CLEAR_SESSION,
    UPDATE_AUDIO_VIDEO,
    SET_TILE_STATUS,
    CLEAR_TILE_STATUS,
    SET_NEW_WAITING_ROOM_MEMBERS,
    CLEAR_NEW_WAITING_ROOM_MEMBER,
    SET_CLIENT_JOINED_IN,
    SET_CLIENT_LEFT_THE_WAITING_ROOM,
    SET_START_SESSION,
    SET_VIDEO,
    SET_AUDIO,
    SET_MIC,
    SET_VIDEO_DEVICE,
    SET_MIC_DEVICE,
    SET_AUDIO_DEVICE,
    SHOW_SELF_VIEW,
    HIDE_SELF_VIEW,
    UPDATE_LOCAL_VIDEO_POSITION,
    TELETHERAPY_SETTINGS_PAGE_STATUS,
    BLUR_BACKGROUND,
    SET_AWS_MEETING_INFO,
    SET_RESOLUTION,
    RESET_TELE_THERAPY_STATE,
} from "../actions/teleTherapyActions";

const initialState = {
    teleTherapySessionData: {},
    clusterListData: {},
    activeRunningSessionData: {
        therapy_sessions: [],
        total: 0,
    },
    client_data: {},
    chime_data: {},
    isReadyToJoin: {},
    attendees: [],
    waitingRoomMembers: [],
    joinData: {},
    isAudioEnabled: true,
    isVideoEnabledFlag: true,
    isMicEnabled: true,
    tileStatus: {},
    newWaitingRoomMembers: {},
    isClientJoinedIn: false,
    startSession: {},
    sessionData: {},
    client_checkin_questionnaire: {},
    videoDevice: null,
    micDevice: null,
    audioDevice: null,
    showSelfView: true,
    blurBackground: false,
    localVideoPosition: null,
    teletherapySettingsPageStatus: false,
    awsMeetingInfo: null
};

export default function teleTherapyStore(
    state: Object = initialState,
    action: Object
): any {
    switch (action.type) {
        case SET_CLUSTER_SESSION_DATA:
            return {
                ...state,
                teleTherapySessionData: action.teleTherapySessionData,
            };
        case SET_CLUSTER_LIST_DATA:
            return {
                ...state,
                clusterListData: action.clusterListData,
            };
        case SET_ACTIVE_RUNNING_SESSION_DATA:
            return {
                ...state,
                activeRunningSessionData: action.activeRunningSessionData,
            };
        case SET_AWS_MEETING_INFO:
            return {
                ...state,
                awsMeetingInfo: action.awsMeetingInfo,
            };
        case SET_CLIENT_DATA:
            return {
                ...state,
                client_data: action.client_data,
            };
        case SET_CLIENT_CHECKIN_QUESTIONNAIRE_DATA:
            return {
                ...state,
                client_checkin_questionnaire:
                    action.client_checkin_questionnaire,
            };
        case SET_CHIME_SESSION_DATA:
            return {
                ...state,
                ...{ chime_data: action.chime_data },
                ...{ isReadyToJoin: action.isReadyToJoin },
            };
        case SET_ATTENDEES:
            return {
                ...state,
                attendees: action.attendees,
            };

        case SET_WAITING_ROOM_MEMBERS: {
            const activeRunningSession = state.activeRunningSessionData; // all current active running session data
            const newMembers = [];

            action.waitingRoomMembers.forEach((memeber) => {
                if (
                    memeber &&
                    activeRunningSession.therapy_sessions.findIndex(
                        (x) =>
                            x.clients[0].client_id ===
                            memeber.clients[0].client_id
                    ) === -1
                ) {
                    newMembers.push(memeber);
                }
            });

            const newSessionState = {
                therapy_sessions: [
                    ...activeRunningSession.therapy_sessions,
                    ...newMembers,
                ],
            };

            return {
                ...state,
                activeRunningSessionData: newSessionState,
            };
        }

        case SET_JOIN_DATA:
            return {
                ...state,
                joinData: action.joinData,
                isReadyToJoin: action.isReadyToJoin,
            };

        case SET_CLIENT_LEFT_THE_WAITING_ROOM: {
            const activeRunningSession = state.activeRunningSessionData;
            const leftMemeber = action.leftWaitingRoomMembers[0];

            const newSessionState = {
                therapy_sessions: activeRunningSession.therapy_sessions.filter(
                    (memeber) =>
                        memeber.clients[0].client_id !== leftMemeber.client_id
                ),
            };

            return {
                ...state,
                activeRunningSessionData: newSessionState,
            };
        }

        case CLEAR_SESSION:
            return {
                ...state,
                attendees: [],
                waitingRoomMembers: [],
                joinData: {},
                isReadyToJoin: false,
                isAudioEnabled: true,
                isVideoEnabledFlag: true,
                isMicEnabled: true,
                tileStatus: {},
                newWaitingRoomMembers: {},
                isClientJoinedIn: false,
                videoDevice: null,
                micDevice: null,
                audioDevice: null,
            };
        case UPDATE_AUDIO_VIDEO:
            return {
                ...state,
                [action.mediaType]: !state[action.mediaType],
            };
        case SET_VIDEO:
            return {
                ...state,
                isVideoEnabledFlag: action.isVideoEnabledFlag,
            };
        case SET_AUDIO:
            return {
                ...state,
                isAudioEnabled: action.isAudioEnabled,
            };
        case SET_MIC:
            return {
                ...state,
                isMicEnabled: action.isMicEnabled,
            };
        case SET_TILE_STATUS:
            return {
                ...state,
                tileStatus: action.tileStatus,
            };
        case CLEAR_TILE_STATUS:
            return {
                ...state,
                tileStatus: {},
            };
        case SET_NEW_WAITING_ROOM_MEMBERS:
            return {
                ...state,
                newWaitingRoomMembers: action.newWaitingRoomMembers,
            };
        case CLEAR_NEW_WAITING_ROOM_MEMBER:
            return {
                ...state,
                newWaitingRoomMembers: {},
            };
        case SET_CLIENT_JOINED_IN:
            return {
                ...state,
                isClientJoinedIn: true,
            };
        case SET_START_SESSION:
            return {
                ...state,
                startSession: action.startSession,
            };
        case SET_VIDEO_DEVICE:
            return {
                ...state,
                videoDevice: action.videoDevice,
            };
        case SET_MIC_DEVICE:
            return {
                ...state,
                micDevice: action.micDevice,
            };
        case SET_AUDIO_DEVICE:
            return {
                ...state,
                audioDevice: action.audioDevice,
            };
        case SHOW_SELF_VIEW:
            return {
                ...state,
                showSelfView: true,
            };
        case HIDE_SELF_VIEW:
            return {
                ...state,
                showSelfView: false,
            };
        case BLUR_BACKGROUND:
            return {
                ...state,
                blurBackground: action.status,
                isVideoEnabledFlag: true// we need to make it true,
                // because if user turned off the camera on waiting room and trying enable and disable on settings,
                // we need to mark the video enabled flag true so that the waiting room video component can show correct status
            };

        case UPDATE_LOCAL_VIDEO_POSITION: {
            const position = action.position;

            return {
                ...state,
                localVideoPosition: position,
            };
        }

        case TELETHERAPY_SETTINGS_PAGE_STATUS: {
            const status = action.status;

            return {
                ...state,
                teletherapySettingsPageStatus: status,
            };
        }

        case SET_RESOLUTION:

            return {
                ...state,
                localVideoResolution: action.resolution,
            };

        case RESET_TELE_THERAPY_STATE:
            return initialState;

        default:
            return state;
    }
}
